<template>
  <section id="trendyol-product-match-home">
    <ProductMatchSearch />
    <ProductMatchProducts />
    <Pagination
      :pagination="_pagination"
      @pageClick="getAllByPage"
    />

    <b-card>
      <b-row>
        <b-col cols="6">
          <b-button-group size="sm">
            <b-button @click="selectAll">
              Tümünü Seç
            </b-button>
            <b-button @click="deselectAll">
              Tümünü Temizle
            </b-button>
            <b-button @click="matchingBarcode">
              Barkodu Eşli Olanlar
            </b-button>
            <b-button @click="matchingName">
              İsmi Eşli Olanlar
            </b-button>
            <b-button @click="selectPending">
              Bekleyenleri Seç
            </b-button>
          </b-button-group>
        </b-col>
        <b-col cols="6">
          <b-button-group>
            <b-button
              title="Seçili olanları eşleştir"
              variant="success"
              @click="setProductsPivotStatusData(2)"
            >Eşleştir
            </b-button>
            <b-button
              title="Seçili olanları Ertele"
              variant="warning"
              @click="setProductsPivotStatusData(5)"
            >Ertele
            </b-button>
            <b-button
              title="Seçili olanları Reddet"
              variant="danger"
              @click="setProductsPivotStatusData(4)"
            >Reddet
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Pagination from '@/components/Pagination.vue'
import ProductMatchSearch from '@/views/trendyol/product-match/ProductMatchSearch.vue'
import ProductMatchProducts from '@/views/trendyol/product-match/ProductMatchProducts.vue'

export default {
  name: 'ProductMatchHome',
  components: {
    ProductMatchSearch,
    ProductMatchProducts,
    Pagination,
  },
  computed: {
    ...mapGetters('tyProductMatch', ['_search', '_pagination', '_products']),
  },
  created() {
    this.getAll()
  },
  methods: {
    getAllByPage(page) {
      this._search.page = page
      this.getAll()
    },
    getAll() {
      this.$store.dispatch('tyProductMatch/getAll')
    },
    setProductsPivotStatusData(statusId) {
      const ids = this._products.flatMap(product => product.ty_all_products
        .filter(tyProduct => tyProduct.matching)
        .map(tyProduct => ({
          ty_product_id: tyProduct.id,
          product_id: product.id,
          status: statusId,
        })))
      this.$store.dispatch('tyProductMatch/setProductsPivotStatusData', ids)
    },
    toSendStatus(statusId) {
      const ids = [{
        ty_product_id: this.tyProduct.id,
        product_id: this.product.id,
        status: statusId,
      }]
      this.$store.dispatch('tyProductMatch/setProductsPivotStatusData', ids)
    },
    selectAll() {
      this.$store.commit('tyProductMatch/selectAll')
    },
    deselectAll() {
      this.$store.commit('tyProductMatch/deselectAll')
    },
    matchingBarcode() {
      this.$store.commit('tyProductMatch/matchingBarcode')
    },
    matchingName() {
      this.$store.commit('tyProductMatch/matchingName')
    },
    selectPending() {
      this.$store.commit('tyProductMatch/selectPending')
    },
  },
}
</script>
